export const actionTypes = {
  UPLOAD_PROGRESS: 'UPLOAD_PROGRESS',
  UPLOAD_START: 'UPLOAD_START',
  UPLOAD_COMPLETE: 'UPLOAD_COMPLETE',
  UPLOAD_ERROR: 'UPLOAD_ERROR',
  UPLOAD_REMOVE: 'UPLOAD_REMOVE',
  UPLOAD_CLEAR: 'PHOTOS_UPLOAD_CLEAR',
};

const uploadsReducer = (state, action) => {
  const { payload } = action;
  const uploads = [...state];
  switch (action.type) {
    case actionTypes.UPLOAD_START:
      uploads.unshift({
        uid: payload.uid,
        file: payload.file,
        title: payload.title,
        status: 'processing',
      });

      return uploads;
    case actionTypes.UPLOAD_COMPLETE:
      return uploads.map((upload) =>
        upload.uid === payload.uid
          ? {
              ...upload,
              status: 'complete',
              photo: payload.photo,
            }
          : upload,
      );

    case actionTypes.UPLOAD_CLEAR:
      return [];

    case actionTypes.UPLOAD_REMOVE:
      return uploads.filter((upload) => upload.uid !== payload.uid);
    default:
      return uploads;
  }
};

export default uploadsReducer;
